import { render } from "./Partner.vue?vue&type=template&id=5268c1c0&ts=true"
import script from "./Partner.vue?vue&type=script&lang=ts"
export * from "./Partner.vue?vue&type=script&lang=ts"

import "./Partner.vue?vue&type=style&index=0&id=5268c1c0&lang=scss"

import exportComponent from "/tmp/build_c94111dd/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__